<div class="ep" [dir]="dir">
  <div class="ep__icon">
    <mat-icon fontSet="material-icons-outlined">warning_amber</mat-icon>
  </div>
  <h2 class="ep__title" translate>error_popup_title</h2>
  <p class="ep__message" [innerHTML]="errorMsg | translate"></p>
  <div class="ep__actions">
    @if (data.action) {
      <button
        mat-stroked-button
        class="ep__btn"
        (click)="action()"
        appTrackClick="error-popup-action-btn"
      >
        {{ data.action.name }}
      </button>
    } @else {
      <button
        mat-stroked-button
        class="ep__btn"
        mat-dialog-close
        appTrackClick="error-popup-close-btn"
      >
        <span translate>Close</span>
      </button>
    }
  </div>
</div>
